const slugify = (phrase: string): string => phrase
  .toString()
  .toLowerCase()
  .trim()
  .replace(/\+/g, '-plus-') // Replace + with '-plus-'
  .replace(/\s+/g, '-') // Replace spaces with -
  .replace(/&/g, '-and-') // Replace & with '-and-'
  .replace(/[^\w-]+/g, ''); // Remove all non-word chars

export default slugify;
